(function (angular) {
  angular
    .module('acme.common.directive.tree.treeNode', ['acme.common.factory.node'])
    .directive('acmeTreeNode', TreeNodeDirective);

  TreeNodeDirective.$inject = [];

  function TreeNodeDirective() {
    TreeNodeController.$inject = ['$element', 'NodeFactory'];

    var id = 0;

    return {
      restrict: 'A',
      require: {
        treeCtrl: '^acmeTree',
        parentTreeNodeCtrl: '?^^acmeTreeNode',
      },
      bindToController: {
        model: '<',
      },
      controllerAs: '$ctrl',
      controller: TreeNodeController,
      link: function ($scope, $element, $attrs) {},
    };

    function TreeNodeController($element, NodeFactory) {
      var ctrl = this;
      var nodeId = 'acme-tree-node-' + ++id;

      ctrl.$onInit = function () {
        $element.addClass('acme-tree-node');

        ctrl.node = new NodeFactory({
          id: nodeId,
          parent: ctrl.parentTreeNodeCtrl || ctrl.treeCtrl,
          value: ctrl,
        });

        if (ctrl.node.parent) {
          ctrl.node.parent.add(ctrl.node);
        }
      };

      ctrl.add = function (node) {
        ctrl.node.add(node);
      };
    }
  }
})(window.angular);
